import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  "aria-atomic": "true",
  class: "alert alert-error",
  role: "alert"
}
const _hoisted_2 = { class: "alert-body" }
const _hoisted_3 = { class: "alert-heading" }
const _hoisted_4 = { class: "alert-text" }
const _hoisted_5 = ["data-cy"]
const _hoisted_6 = { class: "h2" }
const _hoisted_7 = {
  key: 0,
  "aria-atomic": "true",
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_8 = { class: "alert-body" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "alert-heading" }, "Advarsel", -1)
const _hoisted_10 = { class: "alert-text" }
const _hoisted_11 = {
  key: 0,
  "aria-atomic": "true",
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_12 = { class: "alert-body" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "alert-heading" }, "Advarsel", -1)
const _hoisted_14 = { class: "alert-text" }
const _hoisted_15 = {
  class: "fds-modal",
  id: "modal-acceptedCountryChange",
  "aria-hidden": "true",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "modal-id-1-title",
  "data-modal-forced-action": ""
}
const _hoisted_16 = { class: "modal-content" }
const _hoisted_17 = { class: "modal-header" }
const _hoisted_18 = {
  class: "modal-title",
  id: "modal-acceptedCountryChange-title"
}
const _hoisted_19 = { class: "modal-body" }
const _hoisted_20 = { class: "modal-footer" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = {
  key: 0,
  class: "form-group"
}
const _hoisted_23 = ["for"]
const _hoisted_24 = { class: "ml-2" }
const _hoisted_25 = {
  key: 0,
  id: "cvr-hint",
  class: "form-hint"
}
const _hoisted_26 = ["id", "disabled"]
const _hoisted_27 = ["id", "data-error", "disabled", "required", "pattern"]
const _hoisted_28 = {
  key: 1,
  class: "form-group"
}
const _hoisted_29 = {
  class: "form-label",
  for: "registration-number"
}
const _hoisted_30 = { class: "ml-2" }
const _hoisted_31 = ["data-error", "disabled"]
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = {
  class: "form-label",
  for: "name"
}
const _hoisted_34 = ["data-error", "disabled", "pattern"]
const _hoisted_35 = { class: "h5" }
const _hoisted_36 = { class: "ml-2" }
const _hoisted_37 = { class: "nobullet-list p-number-list" }
const _hoisted_38 = {
  key: 0,
  class: "spinner"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("li", null, null, -1)
const _hoisted_40 = ["id", "aria-checked", "checked", "disabled", "value", "onInput"]
const _hoisted_41 = ["for"]
const _hoisted_42 = { class: "h2" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_DataList = _resolveComponent("DataList")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_CompanyInformationAddresses = _resolveComponent("CompanyInformationAddresses")!
  const _component_GenericInput = _resolveComponent("GenericInput")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.formValidation.formErrors.size)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, [
              _createVNode(_component_SimpleText, { "text-key": "sharedContent.formErrorTitle" })
            ]),
            _createElementVNode("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formValidation.formErrors, ([key, value]) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: key,
                  "data-cy": 'error_' + key
                }, _toDisplayString(value), 9, _hoisted_5))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("h2", _hoisted_6, [
      _createVNode(_component_SimpleText, { "text-key": "calculation.contactinfo.title" })
    ]),
    (_ctx.companyInformation)
      ? (_openBlock(), _createElementBlock("form", {
          key: 1,
          onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.formValidation.clearValidField($event))),
          onSubmit: _cache[22] || (_cache[22] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
          onInvalidCapture: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.formValidation.handleFormValidity($event, true)), ["prevent"]))
        }, [
          (_ctx.showAdressValidationWarning)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.adressValidationWarning), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass([{
        'form-error': _ctx.formValidation.formErrors.has('unknown-country')
      }, "form-group mt-6"])
          }, [
            _createVNode(_component_DataList, {
              "value-selected": _ctx.proposedSelectedCountry,
              "onUpdate:valueSelected": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.proposedSelectedCountry) = $event)),
              disabled: _ctx.isPurpose1or2 || _ctx.isReadOnly,
              label: this.country,
              options: _ctx.countryList,
              onInputClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearSelectedCountry())),
              onOptionFoundSuccess: _ctx.countrySelectOnBlur
            }, null, 8, ["value-selected", "disabled", "label", "options", "onOptionFoundSuccess"]),
            (_ctx.showCountryEmissionWarning)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.countryEmissionWarning), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("h2", _hoisted_18, [
                  _createVNode(_component_SimpleText, { "text-key": "masterdatacompanyInformation.changeCountryModalTitle" })
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("p", null, null, 512), [
                  [_directive_dompurify_html, _ctx.changeCountryModalReplacedBodyText]
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "button button-primary",
                  id: "modal-acceptedCountryChange-yes",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeCountry && _ctx.changeCountry(...args)))
                }, [
                  _createVNode(_component_SimpleText, { "text-key": "masterdatacompanyInformation.changeCountryModalButtonChange" })
                ]),
                _createElementVNode("button", {
                  class: "button button-secondary",
                  id: "modal-acceptedCountryChange-no",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.revertChangeCountry && _ctx.revertChangeCountry(...args)))
                }, [
                  _createVNode(_component_SimpleText, { "text-key": "masterdatacompanyInformation.changeCountryModalButtonCancel" })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            (_ctx.selectedCountry.code === 'DK')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("label", {
                    for: _ctx.isPurpose4 ? 'cvr' : 'cvr2',
                    class: "form-label"
                  }, [
                    _createVNode(_component_SimpleText, { "text-key": "calculation.masterdata.text.vat-no" }),
                    _createElementVNode("span", _hoisted_24, [
                      _createVNode(_component_Tooltip, {
                        text: this.cvrTooltip
                      }, null, 8, ["text"])
                    ])
                  ], 8, _hoisted_23),
                  (_ctx.isPurpose1or2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                        _createVNode(_component_SimpleText, { "text-key": "masterdatacompanyInformation.cvrHint" })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isPurpose4)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        id: _ctx.isPurpose4 ? 'cvr' : 'cvr2',
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companyInformation.vatNo) = $event)),
                        disabled: _ctx.isReadOnly,
                        class: "form-input",
                        maxlength: "8",
                        name: "cvr",
                        type: "number",
                        onKeyup: _cache[5] || (_cache[5] = ($event: any) => {_ctx.selectNoPNumbers(); _ctx.loadPNumbers(); _ctx.loadCompanyName();})
                      }, null, 40, _hoisted_26)), [
                        [_vModelText, _ctx.companyInformation.vatNo]
                      ])
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 2,
                        id: _ctx.isPurpose4 ? 'cvr' : 'cvr2',
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.companyInformation.vatNo) = $event)),
                        "data-error": this.errorVatNr,
                        disabled: _ctx.isPurpose1or2 || _ctx.isReadOnly,
                        required: _ctx.selectedCountry.code === 'DK',
                        class: "form-input",
                        name: "cvr2",
                        pattern: _ctx.findRegexPattern('regex.validation.vat-no'),
                        type: "number",
                        onKeyup: _cache[7] || (_cache[7] = ($event: any) => {_ctx.selectNoPNumbers(); _ctx.loadPNumbers(); _ctx.loadCompanyName();})
                      }, null, 40, _hoisted_27)), [
                        [_vModelText, _ctx.companyInformation.vatNo]
                      ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, [
                    _createVNode(_component_SimpleText, { "text-key": "masterdatacompanyInformation.registrationNumber" }),
                    _createElementVNode("span", _hoisted_30, [
                      _createVNode(_component_Tooltip, {
                        text: this.registrationNumberTooltip
                      }, null, 8, ["text"])
                    ])
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    id: "registration-number",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.companyInformation.vatNo) = $event)),
                    "data-error": this.errorRegistrationNumber,
                    disabled: _ctx.isReadOnly,
                    class: "form-input",
                    maxlength: "50",
                    min: "1",
                    name: "registration-number",
                    type: "text"
                  }, null, 8, _hoisted_31), [
                    [_vModelText, _ctx.companyInformation.vatNo]
                  ])
                ]))
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("label", _hoisted_33, [
              _createVNode(_component_SimpleText, { "text-key": "calculation.masterdata.text.company-name" })
            ]),
            _withDirectives(_createElementVNode("input", {
              id: "name",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.companyInformation.companyName) = $event)),
              "data-error": this.errorCompanyName,
              disabled: _ctx.isPurpose1or2 || _ctx.isReadOnly,
              class: "form-input",
              name: "name",
              pattern: _ctx.findRegexPattern('regex.validation.company-name'),
              type: "text"
            }, null, 8, _hoisted_34), [
              [_vModelText, _ctx.companyInformation.companyName]
            ])
          ]),
          (_ctx.selectedCountry.code !== 'DK')
            ? (_openBlock(), _createBlock(_component_CompanyInformationAddresses, {
                key: 1,
                addresses: _ctx.calculationAddresses,
                pCountryCode: _ctx.selectedCountry.code,
                pCountryName: _ctx.selectedCountry.name,
                onAddressValidationWarning: _ctx.onAddressValidationWarning,
                onDeleteAddress: _ctx.onDeleteCalculationAddress,
                onSaveAddress: _ctx.onSaveCalculationAddress
              }, null, 8, ["addresses", "pCountryCode", "pCountryName", "onAddressValidationWarning", "onDeleteAddress", "onSaveAddress"]))
            : _createCommentVNode("", true),
          (_ctx.selectedCountry.code === 'DK')
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass([{
        'form-error':
          _ctx.formValidation.formErrors.has('p-number') ||
          _ctx.formValidation.formErrors.has('no-p-numbers')
      }, "form-group"])
              }, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("legend", _hoisted_35, [
                    _createVNode(_component_SimpleText, { "text-key": "calculation.masterdata.text.p-number" }),
                    _createElementVNode("span", _hoisted_36, [
                      _createVNode(_component_Tooltip, {
                        text: this.pNumberTooltip
                      }, null, 8, ["text"])
                    ])
                  ]),
                  (!_ctx.isReadOnly)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        id: "select-all-p-numbers",
                        class: "function-link",
                        href: "#",
                        onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.selectAllPNumbers()), ["prevent"]))
                      }, [
                        _createVNode(_component_SimpleText, { "text-key": "sharedContent.selectAll" })
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isReadOnly)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        id: "deselect-all-p-numbers",
                        class: "function-link ml-305",
                        href: "#",
                        onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.selectNoPNumbers()), ["prevent"]))
                      }, [
                        _createVNode(_component_SimpleText, { "text-key": "sharedContent.deselectAll" })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("ul", _hoisted_37, [
                    (_ctx.showLoader)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38))
                      : _createCommentVNode("", true),
                    _hoisted_39,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pNumbers, (pNumber) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: pNumber.pNumber
                      }, [
                        _createElementVNode("input", {
                          id: `checkbox-${pNumber.pNumber}`,
                          "aria-checked": _ctx.isPNumberSelected(pNumber),
                          checked: _ctx.isPNumberSelected(pNumber),
                          disabled: _ctx.isReadOnly,
                          value: pNumber,
                          class: "form-checkbox",
                          name: "checkbox-small[]",
                          type: "checkbox",
                          onInput: ($event: any) => (_ctx.onPNumberCheckChanged(pNumber,$event.target.checked))
                        }, null, 40, _hoisted_40),
                        _createElementVNode("label", {
                          for: `checkbox-${pNumber.pNumber}`
                        }, _toDisplayString(pNumber.pNumber + " - " + _ctx.formatAddressDK(pNumber.address)), 9, _hoisted_41)
                      ]))
                    }), 128))
                  ])
                ])
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("h2", _hoisted_42, [
            _createVNode(_component_SimpleText, { "text-key": "calculation.mainresult.text.keynumbers" })
          ]),
          _createElementVNode("p", null, [
            _createVNode(_component_SimpleText, { "text-key": "calculation.mainresult.text.keynumbers.description2" })
          ]),
          _createVNode(_component_GenericInput, {
            id: "employees",
            modelValue: this.numberOfEmployees,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((this.numberOfEmployees) = $event)),
            disabled: _ctx.isReadOnly,
            hintText: this.employeesHint,
            lable: _ctx.getContentfulString('calculation.masterdata.text.number-employees'),
            max: 9999999,
            min: 0,
            showOptionalLabel: true,
            step: 0.01,
            validationError: this.errorEmployees,
            regex: _ctx.findRegexPattern('regex.validation.nummeric.unsigned.max-9-digits.max-2-decimals'),
            onValueInvalid: _cache[13] || (_cache[13] = (arg1, arg2) => _ctx.applyCompanyInformationValidationError(arg1, arg2)),
            onValueValid: _cache[14] || (_cache[14] = (arg1) => _ctx.applyCompanyInformationValidationOk(arg1)),
            type: "DECIMAL",
            "avoid-auto-formatting-decimals": true
          }, null, 8, ["modelValue", "disabled", "hintText", "lable", "validationError", "regex"]),
          _createVNode(_component_GenericInput, {
            id: "revenue",
            modelValue: this.turnover,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((this.turnover) = $event)),
            disabled: _ctx.isReadOnly,
            hintText: this.turnoverHint,
            lable: _ctx.getContentfulString('calculation.masterdata.text.revenue'),
            max: 9999999999999.99,
            min: 0,
            showOptionalLabel: true,
            step: 0.01,
            validationError: this.errorTurnover,
            regex: _ctx.findRegexPattern('regex.validation.nummeric.unsigned.max-17-digits.max-2-decimals'),
            onValueInvalid: _cache[16] || (_cache[16] = (arg1, arg2) => _ctx.applyCompanyInformationValidationError(arg1, arg2)),
            onValueValid: _cache[17] || (_cache[17] = (arg1) => _ctx.applyCompanyInformationValidationOk(arg1)),
            type: "DECIMAL",
            inputmode: "numeric",
            "avoid-auto-formatting-decimals": true
          }, null, 8, ["modelValue", "disabled", "hintText", "lable", "validationError", "regex"]),
          _createVNode(_component_GenericInput, {
            id: "area",
            modelValue: this.buildingSquareMeterArea,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((this.buildingSquareMeterArea) = $event)),
            disabled: _ctx.isReadOnly,
            hintText: this.buildingAreaHint,
            lable: _ctx.getContentfulString('calculation.masterdata.text.building-area'),
            max: 999999999.99,
            min: 0,
            showOptionalLabel: true,
            step: 0.01,
            validationError: this.errorArea,
            regex: _ctx.findRegexPattern('regex.validation.nummeric.unsigned.max-11-digits.max-2-decimals'),
            onValueInvalid: _cache[19] || (_cache[19] = (arg1, arg2) => _ctx.applyCompanyInformationValidationError(arg1, arg2)),
            onValueValid: _cache[20] || (_cache[20] = (arg1) => _ctx.applyCompanyInformationValidationOk(arg1)),
            type: "DECIMAL",
            inputmode: "numeric",
            "avoid-auto-formatting-decimals": true
          }, null, 8, ["modelValue", "disabled", "hintText", "lable", "validationError", "regex"]),
          (!_ctx.isReadOnly)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                id: "submit-button",
                disabled: _ctx.isReadOnly,
                class: "button button-primary mt-705",
                type: "submit"
              }, [
                _createVNode(_component_SimpleText, { "text-key": "sharedContent.next" })
              ], 8, _hoisted_43))
            : _createCommentVNode("", true),
          (_ctx.isReadOnly)
            ? (_openBlock(), _createElementBlock("button", {
                key: 4,
                id: "submit-button",
                disabled: !_ctx.isReadOnly,
                class: "button button-primary mt-705",
                to: "/calculator/energy-and-processes/electricity"
              }, [
                _createVNode(_component_SimpleText, { "text-key": "sharedContent.next" })
              ], 8, _hoisted_44))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_router_link, {
              id: "back-link",
              class: "back-link",
              to: "/calculator/master-data/purpose"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SimpleText, { "text-key": "sharedContent.back" })
              ]),
              _: 1
            })
          ])
        ], 32))
      : _createCommentVNode("", true)
  ], 64))
}